import React, { useEffect } from "react";
import { authServer, appUrl } from "./app_props";
import { clearAuth } from "./authStorage";

const Logout = () => {
  useEffect(() => {
    // Clear the remembered auth mirror (localStorage) and all session state.
    clearAuth();
    sessionStorage.clear();

    // A top-level navigation is required so the browser sends the auth
    // server's session cookie (SameSite blocks it on cross-site fetch/XHR).
    // /exit invalidates the SSO session and redirects back to this app.
    window.location.href =
      authServer + "/exit?redirect_uri=" + encodeURIComponent(appUrl);
  }, []);

  return <div>Logging out...</div>;
};

export default Logout;
